<template>
  <div class="access-alert">
    <div class="mb-6">
      <div class="d-flex align-center mb-2">
        <div class="icon-badge mr-3">
          <v-icon style="font-size: 16px; color: #C62828;">fa:fa-solid fa-triangle-exclamation</v-icon>
        </div>
        <div>
          <div class="text-h6 text-md-h5 font-weight-black text-grey-darken-4" style="line-height: 1.2;">
            {{ errorTitle }}
          </div>
          <div class="text-body-2 text-medium-emphasis mt-1">
            {{ errorMessage }}
          </div>
        </div>
      </div>
    </div>

    <div class="guide-card mb-6">
      <div class="text-subtitle-2 font-weight-bold text-grey-darken-3 mb-3">¿Qué puedes hacer?</div>

      <div class="step-item">
        <v-icon style="font-size: 14px; color: #005691; margin-right: 10px;">fa:fa-regular fa-envelope</v-icon>
        <div>
          <div class="text-body-2 font-weight-bold text-grey-darken-3">Revisa tu correo</div>
          <div class="text-caption text-medium-emphasis">Usa el correo corporativo asociado a tu cuenta.</div>
        </div>
      </div>

      <div class="step-item">
        <v-icon style="font-size: 14px; color: #005691; margin-right: 10px;">fa:fa-solid fa-user-shield</v-icon>
        <div>
          <div class="text-body-2 font-weight-bold text-grey-darken-3">Solicita acceso</div>
          <div class="text-caption text-medium-emphasis">Contacta a soporte o a tu administrador de TI.</div>
        </div>
      </div>

      <div class="step-item">
        <v-icon style="font-size: 14px; color: #005691; margin-right: 10px;">fa:fa-solid fa-headset</v-icon>
        <div>
          <div class="text-body-2 font-weight-bold text-grey-darken-3">Soporte TIC</div>
          <div class="text-caption text-medium-emphasis">El equipo TIC puede ayudarte con el registro.</div>
        </div>
      </div>
    </div>

    <v-btn
      @click="redirectLogin()"
      elevation="0"
      block
      size="large"
      class="font-weight-black py-4 text-capitalize"
      style="background: linear-gradient(135deg, #002B49 0%, #005691 100%); color: white; border-radius: 14px;"
    >
      Regresar al login
      <v-icon style="font-size: 14px; color: white; margin-left: 10px;">fa:fa-solid fa-arrow-right</v-icon>
    </v-btn>

    <div class="d-flex justify-center mt-8">
      <v-img
        :src="require('@/assets/logo-tic.svg')"
        contain
        style="max-width: 140px; max-height: 28px; opacity: 0.85;"
      ></v-img>
    </div>
  </div>
</template>

<script>
import { mapMutations } from 'vuex';

export default{
  data() {
    return {
      errorType: null
    }
  },
  computed: {
    errorTitle() {
      const titles = {
        'user_not_found': 'Acceso denegado',
        'authentication_failed': 'Error de autenticación',
        'default': 'Acceso denegado'
      }
      return titles[this.errorType] || titles.default
    },
    errorMessage() {
      const messages = {
        'user_not_found': 'No encontramos tu cuenta registrada en el sistema.',
        'authentication_failed': 'No se pudo completar la autenticación con Microsoft.',
        'default': 'No encontramos tu cuenta registrada en el sistema.'
      }
      return messages[this.errorType] || messages.default
    }
  },
  mounted() {
    // Capturar el tipo de error de la URL
    this.errorType = this.$route.query.error || 'default'
  },
  methods:{
    ...mapMutations('login', ['switchComponent']),
    redirectLogin(){
      this.switchComponent('FormLoginComponent')
      // Limpiar el parámetro de error de la URL
      this.$router.push({name: 'Login'})
    }
  }
}
</script>

<style scoped>
.icon-badge {
  width: 38px;
  height: 38px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(198, 40, 40, 0.08);
  border: 1px solid rgba(198, 40, 40, 0.14);
}

.guide-card {
  background: rgba(17, 24, 39, 0.03);
  border: 1px solid #EEF2F7;
  border-radius: 16px;
  padding: 16px;
}

.step-item {
  display: flex;
  align-items: flex-start;
  padding: 12px 12px;
  border-radius: 14px;
  background: rgba(255, 255, 255, 0.72);
  border: 1px solid rgba(238, 242, 247, 0.9);
}

.step-item + .step-item {
  margin-top: 10px;
}
</style>

